import { API_ADMIN_ACCESS_LOGS_ROUTE } from "../global/constants/routes/apiConstants";
import {
  AccessLogsResponse,
  ListAdminAccessLogsParams,
} from "../global/types/accessLog";
import { apiService } from "./api";

export const listAdminAccessLogs = async ({
  tz,
  data_inicio,
  data_fim,
  page = 1,
  size = 25,
}: ListAdminAccessLogsParams): Promise<AccessLogsResponse> => {
  const response = await apiService.get<AccessLogsResponse>(
    API_ADMIN_ACCESS_LOGS_ROUTE,
    {
      params: {
        tz,
        data_inicio,
        data_fim,
        page,
        size,
      },
    }
  );

  return response.data;
};
